import { render, staticRenderFns } from "./NotificationPage.vue?vue&type=template&id=3476b6f6&scoped=true&"
import script from "./NotificationPage.vue?vue&type=script&lang=js&"
export * from "./NotificationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3476b6f6",
  null
  
)

export default component.exports